import type { CourseLookupState } from '@/lib/courseLookup';

export function CourseLookupStatus({ state, onRetry }: {
  state: CourseLookupState<unknown>;
  onRetry(): void;
}) {
  const hasStatus = state.selecting || state.status === 'loading' || state.status === 'empty'
    || (state.status === 'idle' && !state.results.length && !state.selected);
  return <>
    {hasStatus ? <div role="status" aria-live="polite">
      {state.selecting ? <p className="t-hint course-lookup-hint">Loading course details…</p> : null}
      {state.status === 'loading' ? <p className="t-hint course-lookup-hint">Searching courses…</p> : null}
      {state.status === 'idle' && !state.selecting && !state.results.length && !state.selected
        ? <p className="t-hint course-lookup-hint">Search by course name or city. Enter at least 2 characters.</p> : null}
      {state.status === 'empty' ? <p className="t-hint course-lookup-hint">No courses found for “{state.query.trim()}”. Try another name or a nearby city, or enter the course manually.</p> : null}
    </div> : null}
    {state.warning ? <div role="alert">
      <p className={state.status === 'error' ? 't-error' : 't-hint course-lookup-hint'}>{state.warning}</p>
      <button type="button" className="t-btn t-btn-ghost" onClick={onRetry}>Try again</button>
    </div> : null}
    {state.selectionError ? <p className="t-error" role="alert">{state.selectionError}</p> : null}
  </>;
}
